/**
 * CSV cells for the Documents and AI exports.
 *
 * Quotes cells that hold a comma, quote or line break, and neutralises spreadsheet formulas: a cell
 * that starts with = + - @ (or a tab / carriage return) gets a leading apostrophe, so a title, remark
 * or model-written cell like "=HYPERLINK(…)" opens in Excel as text instead of running. Plain numbers
 * ("-1,250.00", "+3") are left alone — they cannot be formulas and should stay numbers.
 */
const FORMULA_START = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^[+-]?(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?%?$/;

export function csvCell(value) {
  let text = String(value ?? '');
  if (FORMULA_START.test(text) && !PLAIN_NUMBER.test(text.trim())) text = `'${text}`;
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export const csvRow = (cells) => cells.map(csvCell).join(',');
